import { render, staticRenderFns } from "./NumberPoint.vue?vue&type=template&id=716c80f9"
import script from "./NumberPoint.vue?vue&type=script&lang=js"
export * from "./NumberPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716c80f9')) {
      api.createRecord('716c80f9', component.options)
    } else {
      api.reload('716c80f9', component.options)
    }
    module.hot.accept("./NumberPoint.vue?vue&type=template&id=716c80f9", function () {
      api.rerender('716c80f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/NumberPoint.vue"
export default component.exports